import { formatDate } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { MatIconRegistry } from "@angular/material/icon";
import { MatDialog } from "@angular/material/dialog";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { BaseResizeComponent } from "loi-lti-common";
import { forkJoin } from "rxjs";
import { ActivateModuleDialogComponent } from "../activate.module.dialog/activate.module.dialog.component";
import { ModuleCodeName } from "../home/home.component";
import { ExternalJsonForHtmlModel } from "../models/external-json-for-html.model";
import { ModuleInfoModel } from "../models/moduleinfo.model";
import { SeriesMeetingModel } from "../models/seriesmeeting.model";
import { ContractStatus, ContractType, ModuleModel, ModuleReason, ModuleStatus, ServiceContractModel } from "../models/student.curriculum.model";
import { ExemptionService } from "../services/exemption.service";
import { MembershipService } from "../services/membership.service";
import { ModuleService } from "../services/module.service";
import { SettingsService } from "../services/settings.service";
import { StudentCurriculumService } from "../services/studentcurriculum.service";

@Component({
  selector: 'module.details.component',
  templateUrl: './module.details.component.html',
  styleUrls: ['./module.details.component.scss']
})

export class ModuleDetailsComponent extends BaseResizeComponent implements OnInit {
  moduleId: string;
  studentEid: string;
  aboutTheModuleModus: boolean = false;
  saveMode: string;
  module: ModuleModel;
  serviceContract: ServiceContractModel;
  contractType: ContractType;
  moduleInfo: ModuleInfoModel;
  meetings: SeriesMeetingModel[];
  moduleNames: ModuleCodeName[];
  providerTypeDescriptions: object;
  oerDescription: string;
  oerLearningGoals: string = null;
  oerLearningGoalsCur: string = null;
  oerLearningGoalsMbo: string;
  oerLearningOutcomes: string[] = [];
  oerPriorKnowledge: string;
  oerModuleCanBeRequested: string;
  modulesFaqLink: object;
  activateModuleDialogRef: MatDialogRef<ActivateModuleDialogComponent>;
  activationInProgress: boolean = false;
  imageUrl: string;
  isImageUrlValid: boolean = false;
  changed: boolean = false;
  loading: boolean = true;
  role: string = '';
  exemptions: string [] = [];
  exemptionUrl: string;
  disabledModuleActivation: boolean = false;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private translateService: TranslateService,
    private settingsService: SettingsService,
    private moduleService: ModuleService,
    private membershipService: MembershipService,
    public dialog: MatDialog,
    private studentCurriculumService: StudentCurriculumService,
    private exemptionService: ExemptionService) {
    super();
    this.matIconRegistry.addSvgIcon('icon_backward', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/icon_backward.svg'));
    this.matIconRegistry.addSvgIcon('expand_more', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/expand_more.svg'));
    this.matIconRegistry.addSvgIcon('icon_information', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/information.svg'));
  }

  ngOnInit() {
    this.loading = true;
    super.ngOnInit();
    this.studentEid = this.route.snapshot.paramMap.get('studentEid');
    this.moduleId = this.route.snapshot.paramMap.get('moduleId');
    this.aboutTheModuleModus = this.route.snapshot.paramMap.get('aboutTheModule') == "true";
    this.saveMode = this.route.snapshot.paramMap.get('saveMode');
    if (this.aboutTheModuleModus) {
      this.module = new ModuleModel();
    }
    else {
      this.module = JSON.parse(sessionStorage.getItem('module'));
    }
    this.serviceContract = JSON.parse(sessionStorage.getItem('serviceContract'));
    this.contractType = ContractType.AFSTAND;
    if (this.serviceContract == null || this.serviceContract === undefined) {
      this.studentCurriculumService.getStudentCurriculum().subscribe(studentCurriculum => {
        for (let course of studentCurriculum.courses) {
          var module = course.modules.find(c => c.internalCode === studentCurriculum.contextInternalCourseCode);
          if (module != null && module !== undefined) {
            this.serviceContract = course.serviceContract;
            this.contractType = this.serviceContract.contractType;
          }
        }
        this.exemptionService.getExemptionRequestLink(this.serviceContract.contractId).subscribe(url => {
          this.exemptionUrl = url;
        });
      });
    } else {
      this.exemptionService.getExemptionRequestLink(this.serviceContract.contractId).subscribe(url => {
        this.exemptionUrl = url;
      });
    }
    if (this.serviceContract) {
      this.contractType = this.serviceContract.contractType;
    }
    this.moduleNames = JSON.parse(sessionStorage.getItem('moduleNames'));
    this.role = JSON.parse(sessionStorage.getItem('role'));

    if (['INSTRUCTOR', 'STAFF'].indexOf(this.role.toUpperCase()) != -1) {
      this.getModuleInfo().then(() => {
        console.log('All loading finished');
        super.ngOnInit();
        this.loading = false;
      });
    }

    else { //Role != INSTRUCTOR
      forkJoin([
        this.getMembership(),
        this.getModuleInfo()
      ]).subscribe(() => {
        console.log('All loading finished');
        this.loading = false;
        super.ngOnInit();
      });
    }
  }

  async getMembership() {
    this.membershipService.hasMembership(this.moduleId).subscribe(hasModuleMembership => {
      console.log(`retrieved hasmembership ${hasModuleMembership}`);
      this.activationInProgress = this.module.status == ModuleStatus.ACTIVATED && !hasModuleMembership;
    }, error => console.log(error));
  }

  async getModuleInfo() {
    if (this.saveMode != 'skipModuleInfo') {
      this.moduleService.getModuleInfo(this.moduleId).subscribe(async moduleInfo => {
        this.moduleInfo = moduleInfo;
        let faqUrl = await this.settingsService.getFaqUrl();
        this.disabledModuleActivation = await this.settingsService.getDisableModuleActivation();
        this.modulesFaqLink = {
          modules_faq_link: '<a href="' + faqUrl + '" target="_blank">veelgestelde vragen</a>'
        };
        this.createListOfProviderTypeDescriptions();
        if (this.moduleInfo != null) {
          console.log(`retrieved moduleinfo for module ${this.moduleInfo.sourcedId}`);
          //this.imageUrl = `https://s3.eu-central-1.amazonaws.com/loi.nl` + `'/images/banners/${this.moduleInfo.label}.jpg`;
          this.imageUrl = await this.settingsService.getBannersBaseUrl() + `/${this.moduleInfo.label}.jpg`;
          this.setValidImageUrl();
        }
        if (this.moduleInfo != null && this.moduleInfo.extension != null) {
          let oerDescriptionField = this.moduleInfo.extension.extensionFields.find(e => e.fieldName == "modOERDescription");
          if (oerDescriptionField != null && !oerDescriptionField.fieldValue.isNullOrWhitespace()) {
            this.oerDescription = oerDescriptionField.fieldValue.replace(new RegExp('<a href=', 'g'), '<a target="_blank" href=');
          }
          let oerPriorKnowledgeField = this.moduleInfo.extension.extensionFields.find(e => e.fieldName == "modOERForeknowledge");
          if (oerPriorKnowledgeField != null && !oerPriorKnowledgeField.fieldValue.isNullOrWhitespace()) {
            this.oerPriorKnowledge = oerPriorKnowledgeField.fieldValue.replace(new RegExp('<a href=', 'g'), '<a target="_blank" href=');
          }
          else {
            this.translateService.get('Module_Details_None').subscribe(none => {
              this.oerPriorKnowledge = none;
            });
          }
          let oerLearningGoalsField = this.moduleInfo.extension.extensionFields.find(e => e.fieldName == "modOERLearningGoals");
          if (oerLearningGoalsField != null && !oerLearningGoalsField.fieldValue.isNullOrWhitespace()) {
            this.oerLearningGoals = oerLearningGoalsField.fieldValue;
          }
          let oerLearningGoalsCurField = this.moduleInfo.extension.extensionFields.find(e => e.fieldName == "modOERLearningGoalsCur");
          if (oerLearningGoalsCurField != null && !oerLearningGoalsCurField.fieldValue.isNullOrWhitespace()) {
            this.oerLearningGoalsCur = oerLearningGoalsCurField.fieldValue;
          }
          let oerLearningGoalsMboField = this.moduleInfo.extension.extensionFields.find(e => e.fieldName == "modOERLearningGoalsMbo");
          if (oerLearningGoalsMboField != null && !oerLearningGoalsMboField.fieldValue.isNullOrWhitespace()) {
            this.oerLearningGoalsMbo = oerLearningGoalsMboField.fieldValue;
          }
          //There may be several occurances of a learningoutcome field
          let oerLearningoutcomesHOFields = this.moduleInfo.extension.extensionFields.filter(e => e.fieldName == "modOERLearningoutcomesHO");
          for (let oerLearningoutcomesHOField of oerLearningoutcomesHOFields) {
            if (!oerLearningoutcomesHOField.fieldValue.isNullOrWhitespace()) {
              let html = await this.learningGoalsJsonToHtml(oerLearningoutcomesHOField.fieldValue); //we need the right order, therefore we await the result before continuing
              //empty field in SIS comes as </p>
              if (html != "</p>") {
                this.oerLearningOutcomes.push(html);
              }
            }
          }
          let oerStandardExemptionField = this.moduleInfo.extension.extensionFields.find(e => e.fieldName == "modOERStandardExemption");
          if (oerStandardExemptionField != null && !oerStandardExemptionField.fieldValue.isNullOrWhitespace()) {
            this.exemptions = oerStandardExemptionField.fieldValue.split(';');
          }
        }
        return moduleInfo;
      }, error => {
        console.log(error);
        this.router.navigate(['module_details/:studentEid/:moduleId/:aboutTheModule/:saveMode',
          { studentEid: this.studentEid, moduleId: this.moduleId, aboutTheModule: this.aboutTheModuleModus, saveMode: 'skipModuleInfo' }]).then(() => {
            location.reload();
          });
      });
    }
  }

  learningGoalsJsonToHtml(jsonString: string) {
    let jsonForHtmlModel = new ExternalJsonForHtmlModel(jsonString, this.translateService);
    return jsonForHtmlModel.getHtml();
  }


  loiFormattedDate(date: string): string {
    return formatDate(date, 'dd-MM-yyyy', this.translateService.defaultLang);
  }

  getExemptionInfo(): string {
    return this. isExemption() ? 'Module_Exemption_Can_Be_Requested' : 'Module_Exemption_Cant_Be_Requested';
  }

  isExemption(): boolean {
    if (this.moduleInfo && this.moduleInfo.extension && this.moduleInfo.extension.extensionFields) {
      let oerModuleCanBeRequested = this.moduleInfo.extension.extensionFields.find(e => e.fieldName == "modExemption");
      return oerModuleCanBeRequested != null && oerModuleCanBeRequested.fieldValue === "true"
    }
    return false;
  }

  hasExemptionRequirements(): boolean {
    return this.exemptions && this.exemptions.length > 0;
  }

  async createListOfProviderTypeDescriptions() {
    this.providerTypeDescriptions = {
      'KLASSIKAAL_EXAMEN': this.translateService.get('Provider_Type_' + 'FLEXIBEL_EXAMEN'),
      'EXTERNE_ORGANISATIE': this.translateService.get('Provider_Type_' + 'EXTERNE_ORGANISATIE'),
      'FLEXIBEL_EXAMEN': this.translateService.get('Provider_Type_' + 'FLEXIBEL_EXAMEN'),
      'OP_AANVRAAG': this.translateService.get('Provider_Type_' + 'OP_AANVRAAG'),
      'NIET_VAN_TOEPASSING': this.translateService.get('Provider_Type_' + 'NIET_VAN_TOEPASSING'),
      'NOG_NIET_BEKEND': this.translateService.get('Provider_Type_' + 'NOG_NIET_BEKEND')
    }
  }

  getProviderTypeDescription(type: string) {
    if (!this.providerTypeDescriptions) return "";
    var result = type ? this.providerTypeDescriptions[type.toUpperCase()] : '-';
    return result.value;
  }

  isExemptionOrUnavailable() {
    return [ModuleStatus.EXEMPTION, ModuleStatus.UNAVAILABLE].indexOf(this.module.status) > -1;
  }

  async toWorkspaceClick() {
    const hosts = document.referrer.match(/http[s]?\:\/\/[^\/]+/g);
    const host = hosts && hosts[0];
    let consumerIsNewCampusPortal = await this.settingsService.getConsumerIsNewCampusPortal();
    if (consumerIsNewCampusPortal) {
      if (this.role.toUpperCase() == 'INSTRUCTOR') {
        window.top.location.href = `${host}/Teacher/Module?vioCode=${this.moduleId}`;
      }
      else if (this.role.toUpperCase() == 'STAFF') {
        window.top.location.href = `${host}/Staff/Module?vioCode=${this.moduleId}`;
      }
      else {
        window.top.location.href = `${host}/Student/Module?vioCode=${this.moduleId}`;
      }
    }
    else {
      window.top.location.href = `${host}/access/providerid/${this.moduleId}`;
    }
  }

  backToOverview() {
    this.router.navigate(['/home/:reload', { reload: this.changed }]);
  }

  activateModuleClick(): void {
    if (this.disabledModuleActivation){
      return;
    }
    let width = '600px';
    let height = '200px';

    if (this.isTinyScreen()) {
      width = '100%';
      height = '300px';
    }

    this.activateModuleDialogRef = this.dialog.open(ActivateModuleDialogComponent, {
      width,
      height,
      maxWidth: width,
      data: {
        contractId: this.serviceContract.contractId,
        moduleId: this.moduleId,
        moduleName: this.module.name
      },
      position: { top: '100px' },
      disableClose: false,
      closeOnNavigation: true
    });

    this.activateModuleDialogRef.afterClosed().pipe().subscribe(requestToActivate => {
      if (requestToActivate) {
        this.activationInProgress = true;
        this.membershipService.createMembership(this.moduleId, this.serviceContract.contractId).subscribe(studentCurriculum => {
          sessionStorage.setItem('studentCurriculum', JSON.stringify(studentCurriculum));
          this.module.status = ModuleStatus.ACTIVATED;
          this.membershipService.hasMembership(this.moduleId).subscribe(hasModuleMembership => {
            this.activationInProgress = this.module.status == ModuleStatus.ACTIVATED && !hasModuleMembership;
          });
        });
      }
    });
  }

  moduleNotActivatableTextItem(): string {
    if (this.module.status == ModuleStatus.EXEMPTION) {
      return 'Module_Details_Module_Unavailable_Exemption';
    }
    else {
      switch (this.module.reason) {
        case ModuleReason.NOT_ACTIVATABLE: return 'Module_Details_Module_Unavailable_Not_Activatable';
        case ModuleReason.NO_REMAINING_ACTIVATIONS: return 'Module_Details_Module_Unavailable_No_Activations_Remaining';
        case ModuleReason.MISSING_PREREQUISITES: return 'Module_Details_Module_Unavailable_Prerequisites';
        case ModuleReason.MEETING_OFFER: return 'Module_Details_Module_Unavailable_Meeting_Offer';
        case ModuleReason.NO_SERVICE_CONTRACT: return 'Module_Details_Module_Unavailable_No_Service_Contract';
        case ModuleReason.FUTURE_ACTIVATIONDATE: return 'Module_Details_Module_Unavailable_Future_Activation_Date';
        case ModuleReason.MISSING_APPROVAL_PARENT: return 'Module_Details_Module_Unavailable_Missing_Approval_Parent';
        case ModuleReason.STUDY_FUTURE_STARTDATE: return 'Module_Details_Module_Unavailable_Study_Future_StartDate';
        case ModuleReason.PREVIOUS_VERSION_ACTIVATED: return 'Module_Details_Module_Unavailable_Previous_Version_Activated';
        default: return 'Module_Details_Module_Unavailable';
      }
    }
  }

  setValidImageUrl(): void {
    var img = new Image();
    img.onload = () => { this.isImageUrlValid = true; };
    img.onerror = () => { this.isImageUrlValid = false; };
    img.src = this.imageUrl;
  }

  getModuleName(vioCode: string) {
    let moduleCodeName = this.moduleNames.find(m => m.vioCode == vioCode);
    if (moduleCodeName != null) {
      return moduleCodeName.name;
    }
    else {
      return vioCode;
    }
  }

  getDefaultCreditsUnit(): string {
    let unit = this.module.defaultCreditsUnit;
    if (unit == 'Maanden') {
      unit = unit.toLowerCase();
    } else {
      unit = unit + "'s";
    }
    return unit;
  }
}
